export const ENV_ABSIB_API_URL = process.env.VUE_APP_MS_ABSIB
export const ENV_SEGURIDAD_API_URL = process.env.VUE_APP_MS_SEGURIDAD
export const ENV_CORS = process.env.VUE_APP_CORS || 'null,http://mozilla.github.io,https://mozilla.github.io'
